module.exports = __webpack_public_path__ + "img/scene5-6.5a169e2b.gif";